<template>
    <div class="p-d-entity-box" :class="{'has-value': valueInput}">
        <div class="main-box">
            <div class="value-box" v-if="valueInput">
                <entity-item v-for="(item,index) in items" class="item" :key="index" @mousedown.stop
                             :transform-suggestions-data="transformSuggestionsData"
                             :item="item"
                             :get-suggestion-item-h-t-m-l="getSuggestionItemHTML"
                             :removable="false"
                             :show-locate-button="true"
                             @locateEntityNames="locateEntityNames"
                ></entity-item>
            </div>
            <div v-else class="empty-box">Empty</div>
        </div>
    </div>
</template>

<script>
    import {buildORS, evaluateValueFilled} from "@/utils";
    import EntityItem from "@/components/EntityItem";
    import {itemValueProperty} from "@/config";
    import {getSuggestionItemHTML, transformSuggestionsData} from "@/InputControls/AutocompleteBox";

    function getCompanyEnglishNameVariations(name) {
        let variations = [];
        if (/\blimited\b/i.test(name)) {
            variations.push(name.replace(/\blimited\b/gi, 'ltd'));
            variations.push(name.replace(/\blimited\b/gi, 'ltd.'));
        } else if (/\bltd\.?\b/i.test(name)) {
            variations.push(name.replace(/\bltd\.?\b/gi, 'limited'));
        }
        if (/\bcompany limited\b/i.test(name)) {
            variations.push(name.replace(/\bcompany limited\b/gi, 'co., ltd.'));
        }
        return variations;
    }

    function getEnglishNameVariations(name) {
        let variations = getCompanyEnglishNameVariations(name);
        let cleaned = name.replace(/-THE-$/i, '').trim();
        if (cleaned !== name) {
            variations.push(cleaned);
            variations = variations.concat(getCompanyEnglishNameVariations(cleaned));
        }
        return variations;
    }

    export default {
        name: "PDEntityBox",
        components: {EntityItem},
        props: ['value', 'field'],
        computed: {
            valueInput() {
                let {value} = this;

                return evaluateValueFilled(value);
            },
            items() {
                if (this.value) {
                    const items = [];
                    this.value.forEach(v => {
                        const item = {};
                        item[itemValueProperty] = v;
                        items.push(item);
                    });
                    return items;
                }
                return null;
            }
        },
        methods: {
            getSuggestionItemHTML: getSuggestionItemHTML,
            transformSuggestionsData: transformSuggestionsData,
            locateEntityNames(payload) {
                const {nameEn, nameCh} = payload.detail;
                let names = [];
                if (nameEn) {
                    names.push(nameEn);
                    names = names.concat(getEnglishNameVariations(nameEn));
                }
                if (nameCh) {
                    names.push(nameCh);
                }
                if (!names.length) {
                    return;
                }

                this.$emit('highlightTextInViewerForItem', {context: buildORS(...names)});
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/variables";

    .main-box {
        border: 1px solid #c0c0c0;
        padding: 2px 0.25rem;
        border-radius: 4px;
        background-color: white;
        min-height: 23px;
    }

    .has-value {
        .main-box {
        }
    }

    .value-box {
        line-height: 1.1rem;
        max-height: 180px;
        overflow: auto;
    }

    .empty-box {
        font-style: italic;
        color: gray;
    }

    .item {
        display: inline-block;
    }
</style>
